import { render, staticRenderFns } from "./Form-Register-Ds49.vue?vue&type=template&id=6dc5fa28&scoped=true&"
import script from "./Form-Register-Ds49.vue?vue&type=script&lang=js&"
export * from "./Form-Register-Ds49.vue?vue&type=script&lang=js&"
import style0 from "./Form-Register-Ds49.vue?vue&type=style&index=0&id=6dc5fa28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc5fa28",
  null
  
)

export default component.exports